import { Divider, Text } from '@macarongfactory/web-ui'

import StarRating from './StarRating'

interface IReviewSummaryCardProps {
  /** 평균 평점 (예: 4.7) */
  averageScore: number
  /** 세그먼트 내 만족도 순위 */
  satisfactionRank: number
  /** 세그먼트명 (예: '대형 SUV') */
  segment: string
}

/** 순위 표기 상한 — 이 값 이상은 '100위+'로 노출 */
const RANK_CAP = 100
/** 요약 카드 별점 크기(px) */
const SUMMARY_STAR_SIZE_PX = 14

const formatRank = (rank: number) =>
  rank >= RANK_CAP ? `${RANK_CAP}위+` : `${rank}위`

/** 순위 없음 케이스 별 아이콘 크기(px) — Figma 9184:43204 rate 20px */
const SCORE_ONLY_STAR_SIZE_PX = 20

/**
 * 오너 후기 요약 카드 — 평균 평점·별점 | 세그먼트 만족도 순위.
 * 좌우 2분할을 세로 구분선으로 나눈다.
 * 만족도 순위가 없으면(모터사이클 등 순위 미산정) 점수+별점만 가로 배치한
 * 컴팩트 카드로 노출한다 (Figma 9184:43204).
 */
const ReviewSummaryCard = ({
  averageScore,
  satisfactionRank,
  segment,
}: IReviewSummaryCardProps) => {
  // 순위 없음(모터사이클 등) 또는 세그먼트 미제공 — 점수(30px) + 별점(20px) 가로 1줄
  // 컴팩트 카드로 노출. 세그먼트가 없으면 '{세그먼트} 만족도 순위'는 맥락이 없어 미노출한다.
  if (satisfactionRank <= 0 || !segment) {
    return (
      <div className='mx-dimension-x5 flex items-center gap-dimension-x1 rounded-dimension-x4 border border-stroke-neutral-strong bg-background-surface-default px-dimension-x4 py-dimension-x3'>
        <Text
          variant='display-1-semibold'
          color='text-foreground-neutral-strong'
        >
          {averageScore.toFixed(2)}
        </Text>
        <StarRating rating={averageScore} size={SCORE_ONLY_STAR_SIZE_PX} />
      </div>
    )
  }

  return (
    <div className='mx-dimension-x5 flex items-center justify-center gap-dimension-x4 rounded-dimension-x4 border border-stroke-neutral-strong bg-background-surface-default px-dimension-x4 py-dimension-x5 shadow-weak'>
      <div className='flex flex-1 flex-col items-center gap-dimension-x1'>
        <Text
          variant='display-1-semibold'
          color='text-foreground-neutral-strong'
        >
          {averageScore.toFixed(2)}
        </Text>
        <StarRating rating={averageScore} size={SUMMARY_STAR_SIZE_PX} />
      </div>

      <Divider.Vertical height='x10' />

      <div className='flex flex-1 flex-col items-center'>
        <Text
          variant='display-1-semibold'
          color='text-foreground-neutral-strong'
        >
          {formatRank(satisfactionRank)}
        </Text>
        <Text
          variant='body-1-medium'
          color='text-foreground-neutral-alternative'
        >
          {segment} 만족도
        </Text>
      </div>
    </div>
  )
}

export default ReviewSummaryCard
